// @ts-nocheck
import {API_ENDPOINT_CCS} from '../../../config/settings';
import {createApi} from '@reduxjs/toolkit/query/react';
import {axiosBaseQuery} from "../../../utils/axios-base-query";
import refundEndpoints, {type as refundType} from './refundEndpoints';
import userEndpoints, {type as userType} from './userEndpoints';
import roleEndpoints, {type as roleType} from './roleEndpoints';
import officeEndpoints, {type as officeType} from './officeEndpoints';
import formOfPaymentEndpoints, {type as formOfPaymentType} from './formOfPaymentEndpoints';
import issueOfficeEndpoints, {type as issueOfficeType} from './issueOfficeEndpoints';
import residentValidateEndpoints, {type as residentValidateType} from "./residentValidateEndpoints";
import receiptEndpoints, {type as receiptType} from "./receiptEndpoints";
import claimEndpoints, {type as claimType} from './claimEndpoints';
import invoiceEndpoints, {type as invoiceType} from './invoiceEndpoints';
import activitiesEndpoints, {type as activityType} from './activitiesEndpoints';
import declarationsEndpoints, {type as declarationsType} from './declarationsEndpoints';

// Define a service using a base URL and expected endpoints
export const api = createApi({
  reducerPath: 'ccsAPI',
  baseQuery: axiosBaseQuery({ baseUrl: API_ENDPOINT_CCS }),
  tagTypes: [refundType, userType, roleType, officeType, formOfPaymentType,receiptType, issueOfficeType, residentValidateType, claimType, invoiceType, activityType, declarationsType],
  keepUnusedDataFor: 30,
  endpoints: (builder) => ({
    ...refundEndpoints(builder),
    ...userEndpoints(builder),
    ...roleEndpoints(builder),
    ...officeEndpoints(builder),
    ...receiptEndpoints(builder),
    ...formOfPaymentEndpoints(builder),
    ...issueOfficeEndpoints(builder),
    ...residentValidateEndpoints(builder),
    ...claimEndpoints(builder),
    ...invoiceEndpoints(builder),
    ...activitiesEndpoints(builder),
    ...declarationsEndpoints(builder),
  })
});
// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetRefundsQuery,
  useGetRefundQuery,
  useGetRefundHistoryQuery,
  useGetRefundCommentsQuery,
  useGetRefundSubjectMutation,
  useCreateRefundMutation,
  useEditRefundMutation,
  useDeleteRefundMutation,
  usePrintRefundMutation,
  useSendByEmailRefundMutation,
  useGetAttachmentsQuery,
  useAddAttachmentsMutation,
  useDownloadAttachmentsMutation,
  useCancelRefundMutation,
  useCloseRefundMutation,

  useGetUsersByPatternMutation,
  useGetUsersQuery,
  useGetUserQuery,
  useAddUserMutation,
  useDeleteUserMutation,
  useEditUserMutation,
  useGetAzureUsersMutation,
  useGetCurrentUserQuery,

  useGetRolesByPatternMutation,
  useGetRolesQuery,
  useGetAllRolesQuery,
  useGetRoleQuery,
  useCreateRoleMutation,
  useUpdateRoleMutation,
  useDeleteRoleMutation,
  useGetRolesSearchMutation,

  useGetOfficesQuery,
  useCreateOfficeMutation,
  useEditOfficeMutation,
  useDeleteOfficeMutation,

  useGetFormsOfPaymentQuery,
  useCreateFormOfPaymentMutation,
  useEditFormOfPaymentMutation,
  useDeleteFormOfPaymentMutation,

  useGetIssueOfficesQuery,
  useCreateIssueOfficeMutation,
  useEditIssueOfficeMutation,
  useDeleteIssueOfficeMutation,

  useResidentValidateMutation,
  useCheckResponsibilityTermQuery,
  useUpdateResponsibilityTermMutation,

  useReceiptRequestMutation,
  useGetClaimStatusMutation,

  useGetInvoicesQuery,
  useEditInvoiceMutation,
  useSendInvoiceMutation,
  useDownloadInvoiceMutation,

  useGetActivitiesQuery,
  useGetProfileActivitiesQuery,
  useGetActivitiesDownloadMutation,

  useGetFlightsMutation,
  useGetFlightMutation,
  useGetFlownPaxMutation,
  useGetTicketInfoMutation,
  useGenerateDelayDeclarationMutation,
  useGenerateBoardingDeclarationMutation,
  useGenerateCancellationDeclarationMutation,
  useGenerateTicketUsageDeclarationMutation,
  useScheduleTicketUsageDeclarationMutation,
  useGetScheduledTicketUsageDeclarationsMutation,

  endpoints
} = api;

export default api;
